module.exports = __webpack_public_path__ + "static/media/donovan-pic.679dc5ab.jpg";